<template>
  <b-carousel id="carousel" v-model="slide" :interval="0" controls indicators background1="#8a8c8d"
    @sliding-start="onSlideStart" @sliding-end="onSlideEnd" :no-animation="false" class="smaller-prev-next">
    <b-carousel-slide>
      <template v-slot:img>
        <b-container class="" fluid>
          <b-row>
            <b-col class="col-5-half pt-4 gray-background"></b-col>
            <b-col class="col-6-half pt-4 white-background pr-0 mr-0"></b-col>
          </b-row>

          <b-row class="image-container-row">
            <!-- PREV Padding -->
            <b-col class="col-half gray-background"></b-col>

            <!-- First Column -->
            <b-col cols="5" class="mx-auto px-0 mx-0 white-text gray-background">
              <div class="d-flex flex-column">
                <div class="align-self-end">
                  <img class="img-height-max mr-3" height="200" src="/images/cv/1/right.jpg" />
                </div>

                <div class="person-text">
                  ARKITEKT MAA <br />
                  FHV LEKTOR PARTNER KGL. BYGNINGSINSPEKTØR<br />
                  NIELS VIUM<br />
                  MARSELISVEJ 10<br />
                  8000 AARHUS C<br />
                  +45 21 63 06 90<br />
                  <a href="mailto:nielsvium@marselisvej.dk">nielsvium@marselisvej.dk</a><br />
                  <a href="https://www.nielsvium.dk">www.nielsvium.dk</a><br />
                  CVR: 39768305<br />
                  Foto: Niels Vium 2022 <br />
                  Links:
                  <a class="to-front" target="_blank" href="https://jettevohlert.dk/">www.jettevohlert.dk</a>
                  og
                  <a target="_blank" href="http://www.arkhist.dk/videoer">www.arkhist.dk/videoer</a>
                </div>
              </div>
            </b-col>
            <!-- Second Column -->
            <b-col cols="6" class="mx-auto px-0 white-background negative-pm">
              <dl class="row small-text mx-4">
                <dt class="col-sm-3 pl-cv">Født:</dt>
                <dd class="col-sm-9 pr-0">Niels Vium 05.12.1947 Ringkøbing</dd>

                <dt class="col-sm-3 pl-cv">Uddannelse:</dt>
                <dd class="col-sm-9 pr-0">
                  Student 1968, Vestjysk Gymnasium, Tarm<br />
                  Arkitekt 1968-1974, Arkitektskolen i Aarhus<br />
                </dd>

                <dt class="col-sm-3 pl-cv">Ansættelser:</dt>
                <dd class="col-sm-9 pr-0">
                  Undervisningsassistent, Arkitektskolen i Aarhus, 1974-1990<br />
                  Lektor, Arkitektskolen i Aarhus, 1991-95<br />
                  Assistant Professor, Virginia University, USA, 1977<br />
                  Assistant Professor, Ball State University, USA, 1989<br />
                  Diverse tegnestueansættelser 1974-1977<br />
                  Ansat hos Kjær & Richter, 1977-1985<br />
                  Medindehaver af Kjaer & Richter A/S, 1986-2016<br />
                  Bestyrelsesformand Kjaer & Richter A/S 2003-2013<br />
                  Kgl. Bygningsinspektør for Jylland 1996-2016<br />
                  Bygningssagkyndig ved Vor Frue kirke Aarhus 2016 -<br />
                </dd>

                <dt class="col-sm-3 pl-cv">Medlemskab:</dt>
                <dd class="col-sm-9 pr-0">
                  Medlem af Kunstnersamfundet, 1983-<br />
                  Medlem af Akademiet for De Skønne Kunster 1990-2015<br />
                  Medlem af Akademirådet for De Skønne Kunster 1991-1995<br />
                  Medlem af bestyrelsen for Selskabet for Arkitekturhistorie
                  1991-1994<br />
                  Medlem af Akademirådets Udvalg for Kirkekunst 1991-1995<br />
                  Fagdommer i omkring 12 arkitekturkonkurrencer<br />
                  Censor ved arkitektskolerne i Aarhus, København og Aalborg
                  1976–2016<br />
                </dd>

                <dt class="col-sm-3 pl-cv">Priser og Legater:</dt>
                <dd class="col-sm-9 pr-0">
                  Modtaget Fritz Schlegels Legat 1983<br />
                  Modtaget Akademiets Herholdt Legat 1988<br />
                  Modtaget Statens Kunstfonds rejselegat 1992<br />
                  Modtaget San Cataldo Legatet 1994<br />
                  Modtaget Eckersberg Medaljen 1998<br />
                  Modtaget Betonelementprisen 1999<br />
                </dd>
              </dl>
            </b-col>
            <!-- NEXT Padding -->
            <b-col class="white-background col-half"></b-col>
          </b-row>

          <b-row>
            <b-col class="col-5-half pt-4 gray-background"></b-col>
            <b-col class="col-6-half pt-4 white-background pr-0 mr-0"></b-col>
          </b-row>

          <ImageDescriptionRow leftText="CV OG KONTAKT" />
        </b-container>
      </template>
    </b-carousel-slide>
    <b-carousel-slide>
      <template v-slot:img>
        <b-container class="" fluid>
          <b-row>
            <b-col class="col-5-half pt-4 gray-background"></b-col>
            <b-col class="col-6-half pt-4 white-background pr-0 mr-0"></b-col>
          </b-row>

          <b-row class="image-container-row">
            <!-- PREV Padding -->
            <b-col class="col-half gray-background"></b-col>

            <!-- First Column -->
            <b-col cols="5" class="mx-auto px-0 pt-0 white-text gray-background">
              <div class="d-flex flex-column justify-content-center align-content-center">
                <div class="align-self-center">
                  <img class="img-height-max" width="340" src="/images/cv/2/top.jpg" />
                </div>

                <div class="align-self-center">
                  <p class="big-font m-0">
                    University of Virginia Charlotsville USA 1977
                  </p>
                </div>

                <div class="align-self-center">
                  <img class="img-height-max" width="340" src="/images/cv/2/bottom.jpg" />
                </div>
              </div>
            </b-col>
            <!-- Second Column -->
            <b-col cols="6" class="mx-auto px-0 pt-0 white-background negative-pm small-text">
              <dl class="row mx-4">
                <dt class="col-sm-2">Arbejder bl.a.:</dt>
                <dd class="col-sm-10">
                  Musikhuset i Aarhus 1977-1982<br />
                  Kreditforeningen Danmark, Aarhus 1980-1984<br />
                  Boligbebyggelser i London 1985-1992<br />
                  Foyer, De Danske Spritfabrikker 1987<br />
                  Tilsyn med omkring 60 af Statens fredede bygninger i Jylland
                  1996-2016<br />
                  Tilsyn med omkring.1400 kirker i Jylland for
                  Stiftsøvrighederne 1996-2016<br />
                  3 Boligbyggerier i London Docklands 1984-1992<br />
                  Forslag til nybygning ved Marmorkirken i København 1992<br />
                  Ny bispebolig i Aarhus 1994 - 96<br />
                  Auditorium og Udstillingsbygning, Arkitektskolen i Aarhus
                  1996-1997<br />
                  Våbenhus i Skrydstrup kirke 1998-2000<br />
                  Bro og orangeri på Herregårdsmuseet Gammel Estrup,
                  1998-2016<br />
                  Restaurering og tilbygning af hovedbygningen på Kalø Gods
                  1996-2016<br />
                  Forslag til tilbygning ved Borgen Spøttrup 2004<br />
                  Forslag til ombygning af Staldgården ved Koldinghus 2004<br />
                  Restaurering af Aalborg Toldkammer 2004-2006<br />
                  Klubhus Stensballegård Golfklub 2008-2009<br />
                  Restaurering af Aakjær Gods 2008-2010<br />
                  Facadeistandsættelse Marselisborg Slot 2010-2015<br />
                  Forslag til sognehus Holmens Kirke 2008<br />
                  Forslag til sognehus Ribe Domkirke 2011<br />
                  Restaurering af Hjørring Amtmandsbygning 2012-2013<br />
                  Restaurering af Ribe Bispegård 2014<br />
                  Forslag til Vagtbygning ved Marselisborg Slot 2014 –<br />
                  Ny Herregård i Nordjylland 2017–21<br />
                  Kirkekrone Vor Frue kirke Aarhus 2022<br />
                </dd>

                <dt class="col-sm-2"></dt>
                <dd class="col-sm-10">
                  Arbejder fra perioden 1977 – 2016 er udført i Kjaer og Richter regi.
                </dd>
              </dl>
            </b-col>
            <!-- NEXT Padding -->
            <b-col class="white-background col-half"></b-col>
          </b-row>

          <b-row>
            <b-col class="col-5-half pt-4 gray-background"></b-col>
            <b-col class="col-6-half pt-4 white-background pr-0 mr-0"></b-col>
          </b-row>

          <ImageDescriptionRow leftText="CV OG KONTAKT" />
        </b-container>
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import ImageDescriptionRow from "@/components/ImageDescriptionRow.vue";

export default {
  name: "cv",
  components: {
    ImageDescriptionRow
  },
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart() {
      // window.console.log(slide);
      this.sliding = true;
    },
    onSlideEnd() {
      // window.console.log(slide);
      this.sliding = false;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/variables.scss";

.small-text {
  font-size: 11px;
  line-height: initial;
}

.white-text {
  color: white;

  a {
    color: white;
    text-decoration: underline;
  }
}

.negative-pm {
  margin-top: -20px;
}

.person-text {
  font-size: 15px;
}

dl {
  padding: 0;
  margin: 0;
}
</style>
